import type { EventStatus, ProgramEventListType, ProgramEventStatus } from 'models';
import { useIsLiveStatus } from './useIsLiveStatus';

export const useShouldShowLiveTag = ({
  endTime,
  eventType,
  startTime,
  status,
}: {
  endTime: Date;
  eventType: ProgramEventListType;
  startTime: Date;
  status: EventStatus | ProgramEventStatus;
}) => {
  const isLive = useIsLiveStatus({ endTime, startTime, status });

  return isLive && eventType !== 'reminder';
};
